import { useTranslation } from "react-i18next";
import HyFlag from "../../assets/images/hy.png";
import EnFlag from "../../assets/images/en.png";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const availableLanguages = [
    {
      key: "en",
      flag: EnFlag,
    },
    {
      key: "hy",
      flag: HyFlag,
    },
  ];

  return (
    <div className="floating-action-button d-flex flex-column gap-2">
      {availableLanguages.map((lang) => (
        <button
          key={lang.key}
          onClick={() => handleChangeLanguage(lang.key)}
          className="btn border border-light bg-white rounded-circle p-2"
        >
          <img src={lang.flag} alt={lang.key} width={30} className="w-15" />
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
